import type { PreProcessor } from './types';

export class PreProcessorFactory {
  createAll(): PreProcessor[] {
    return [];
  }
}
